/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedContentModuleBannerTiles_browseContentModule = {
    readonly title: string | null;
    readonly description: string | null;
    readonly mainImage: string | null;
    readonly termsLink: string | null;
    readonly tiles: ReadonlyArray<{
        readonly imageUrl: string | null;
        readonly title: string | null;
        readonly linkData: {
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
    } | null> | null;
    readonly " $refType": "SbSharedContentModuleBannerTiles_browseContentModule";
};
export type SbSharedContentModuleBannerTiles_browseContentModule$data = SbSharedContentModuleBannerTiles_browseContentModule;
export type SbSharedContentModuleBannerTiles_browseContentModule$key = {
    readonly " $data"?: SbSharedContentModuleBannerTiles_browseContentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedContentModuleBannerTiles_browseContentModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedContentModuleBannerTiles_browseContentModule",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "termsLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrowseContentModuleTile",
      "kind": "LinkedField",
      "name": "tiles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentModuleBannerTiles",
  "abstractKey": null
};
})();
(node as any).hash = '76fb6b7fc270a2fe2efdf7dbcf999084';
export default node;
